module.exports = __webpack_public_path__ + "static/Cases6-b47aa5625857bd4c9efea7b794a7908a.svg";